<template>
  <main
    id="create-item-page"
    class="page-container"
    v-if="$route.name === 'add-product'"
  >
    <!-- messaggi di stato -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <form class="create-item-form" @submit.prevent="onSubmit">
      <div class="create-item-row row-0">
        <!-- selettore di articolo -->
        <div class="field">
          <label>Tipo di articolo</label>
          <AppSelect
            v-model="itemChoice"
            :options="itemChoiceOptions"
            placeholder="— scegli —"
          />
        </div>
      </div>
      <!-- riga base -->
      <div class="create-item-row row-1">
        <div class="field" v-if="itemChoice === 'piastrelle'">
          <label for="item-name">Nome articolo *</label>
          <input
            id="item-name"
            type="text"
            v-model.trim="form.itemName"
            placeholder="es. Wall White"
          />
        </div>
        <div class="field" v-if="itemChoice === 'piastrelle'">
          <label for="sqmQuantity">Quantità in Mq *</label>
          <input
            id="sqmQuantity"
            type="number"
            v-model.number="form.sqmQuantity"
            min="0"
            step="0.01"
            placeholder="es. 50mq"
          />
        </div>
        <div class="field" v-if="itemChoice === 'piastrelle'">
          <label for="widthCm">Larghezza (cm)</label>
          <input
            id="widthCm"
            type="number"
            v-model.number="form.widthCm"
            min="1"
            step="1"
            placeholder="es. 50"
          />
        </div>
        <div class="field" v-if="itemChoice === 'piastrelle'">
          <label for="heightCm">Altezza (cm)</label>
          <input
            id="heightCm"
            type="number"
            v-model.number="form.heightCm"
            min="1"
            step="1"
            placeholder="es. 50"
          />
        </div>

        <!-- sotto i due campi width/height -->
        <small v-if="isTiles && measurePreview" class="measure-preview">
          Anteprima misura: {{ measurePreview }}
        </small>

        <div
          class="field"
          v-if="itemChoice === 'sanitari' || itemChoice === 'altro'"
        >
          <label for="brandTile">Brand</label>
          <input
            id="brandTile"
            type="text"
            v-model="form.brand"
            placeholder="es. Cesame"
          />
        </div>
        <div
          class="field"
          v-if="itemChoice === 'sanitari' || itemChoice === 'altro'"
        >
          <label for="subBrandTile">Modello</label>
          <input
            id="subBrandTile"
            type="text"
            v-model="form.subBrand"
            placeholder="es. GRAN MASCALZONE"
          />
        </div>
      </div>

      <hr />
      <div class="create-item-row row-2">
        <div
          class="field"
          v-if="itemChoice === 'sanitari' || itemChoice === 'altro'"
        >
          <label for="item-quantity">Pezzi</label>
          <input
            id="item-quantity"
            type="number"
            v-model="form.quantity"
            min="0"
            placeholder="es. 100"
          />
        </div>

        <div
          class="field"
          v-if="itemChoice === 'sanitari' || itemChoice === 'altro'"
        >
          <label for="item-price">Prezzo (€)</label>
          <input
            id="item-price"
            type="number"
            v-model.number="form.price"
            min="0"
            step="0.01"
            placeholder="€0.00"
          />
        </div>
        <div class="field" v-if="itemChoice === 'piastrelle'">
          <label for="sqmPrice"> Prezzo al Mq *</label>
          <input
            id="sqmPrice"
            type="number"
            v-model.number="form.sqmPrice"
            min="0"
            step="0.01"
            placeholder="€0.00"
          />
        </div>
      </div>
      <!-- submit -->
      <div class="save-button-container">
        <button
          id="create-item-button"
          type="submit"
          :disabled="!canSubmit"
          :aria-disabled="!canSubmit"
          :title="
            !canSubmit
              ? 'Compila tutti i campi obbligatori'
              : 'Salva articolo fuori magazzino'
          "
        >
          Salva
        </button>
      </div>
    </form>
  </main>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.cjs.js";

export default {
  name: "CreateItemPage",
  watch: {
    itemChoice(newVal) {
      // quando l’utente cambia scelta
      if (newVal === "sanitari") {
        this.form.itemName = "";
        this.form.subCategory = "sanitari";
        this.form.sqmPrice = 0;
        this.form.sqmQuantity = "";
        this.form.widthCm = "";
        this.form.heightCm = "";
      } else if (newVal === "piastrelle") {
        this.form.brand = "";
        this.form.subBrand = "";
        this.form.subCategory = "piastrelle";
        this.form.price = 0;
      } else if (newVal === "altro") {
        this.form.subCategory = "altro";
        this.form.itemName = "";
        this.form.sqmPrice = 0;
        this.form.sqmQuantity = "";
        this.form.widthCm = "";
        this.form.heightCm = "";
      }
    },
  },
  data() {
    return {
      errorMessage: "",
      successMessage: "",
      itemChoice: "",
      // [sc-49210] Opzioni del menu a tendina
      itemChoiceOptions: [
        { value: "piastrelle", label: "Piastrelle" },
        { value: "sanitari", label: "Sanitari" },
        { value: "altro", label: "Altro" },
      ],
      form: {
        quantity: 0,
        itemName: "",
        subCategory: "",
        category: "",
        sqmQuantity: "",
        sqmPrice: 0,
        brand: "",
        subBrand: "",
        price: 0,
        widthCm: "",
        heightCm: "",
      },
    };
  },
  computed: {
    isTiles() {
      return this.itemChoice === "piastrelle";
    },
    isSanAlt() {
      return this.itemChoice === "sanitari" || this.itemChoice === "altro";
    },
    canSubmit() {
      if (!this.itemChoice) return false;

      // Piastrelle: nome + mq + prezzo mq
      if (this.isTiles) {
        const nameOk = (this.form.itemName || "").trim().length > 0;
        const qtyOk = Number(this.form.sqmQuantity) > 0;
        const priceOk = Number(this.form.sqmPrice) > 0;
        const widthOk =
          this.form.widthCm === "" ||
          (Number.isFinite(+this.form.widthCm) && +this.form.widthCm > 0);
        const heightOk =
          this.form.heightCm === "" ||
          (Number.isFinite(+this.form.heightCm) && +this.form.heightCm > 0);
        return nameOk && qtyOk && priceOk && widthOk && heightOk;
      }

      // Sanitari/Altro: brand e prezzo (>0)
      if (this.isSanAlt) {
        const brandOk = (this.form.brand || "").trim().length > 0;
        const subBrandOk =
          (this.form.subBrand || "").trim().length > 0 ||
          this.itemChoice === "altro";
        return brandOk && subBrandOk && Number(this.form.price) > 0;
      }

      return false;
    },

    measurePreview() {
      if (!this.isTiles) return "";
      const w = Number(this.form.widthCm);
      const h = Number(this.form.heightCm);
      if (Number.isFinite(w) && Number.isFinite(h) && w > 0 && h > 0) {
        return `${h}x${w} cm`;
      }
      return "";
    },
  },
  methods: {
    ...mapActions(["createOutstock"]),
    resetForm() {
      this.form = {
        itemName: "",
        subCategory: "",
        sqmQuantity: 0,
        sqmPrice: 0,
        quantity: 0,
        category: "",
        brand: "",
        subBrand: "",
        price: 0,
      };
    },
    //* Considerare di implementare il calcolo dell'iva..
    async onSubmit() {
      this.errorMessage = "";
      this.successMessage = "";

      const payload = { ...this.form };
      // console.log("payload", payload);
      // console.log("thisform", this.form);

      // Evita di spedire “spazzatura”
      if (!this.isTiles) {
        delete payload.widthCm;
        delete payload.heightCm;
        delete payload.sqmQuantity; // se non ti serve per sanitari/altro
        delete payload.sqmPrice;
      } else {
        // width/height facoltativi: lasciali se numerici, altrimenti rimuovi
        const w = Number(payload.widthCm);
        const h = Number(payload.heightCm);
        if (!(Number.isFinite(w) && Number.isFinite(h) && w > 0 && h > 0)) {
          delete payload.widthCm;
          delete payload.heightCm;
        }
      }
      // NON inviare measureDesc: lo calcola il server
      delete payload.measureDesc;

      try {
        const res = await this.createOutstock(payload);
        this.successMessage =
          res.data?.message || "Articolo fuori magazzino creato!";
        this.$toast.success(this.successMessage);
        this.resetForm();
        const routeName = "orders";
        setTimeout(() => this.$router.push({ name: routeName }), 800);
      } catch (err) {
        this.errorMessage =
          err.response?.data?.details ||
          err.response?.data?.error ||
          "Errore durante la creazione.";
        this.$toast.error(this.errorMessage);
      }
    },
  },
};
</script>

<style src="@/css/CreateItemPage.css"></style>
